export default __webpack_public_path__ + "static/media/malaysia-decides.d0b75a6d.png";